import React from 'react';
import { SaveOutlined } from '@ant-design/icons';
import {Button } from "antd";
import { Form } from "react-final-form";
import arrayMutators from 'final-form-arrays'

import { FormFieldType, FormField } from "../../Components";
import { i18, trb } from "@utilities";

const ButtonGroup = Button.Group;

export const ListKycFilter = (props) => {
    return (
        <div className="form bbs_kyc_form">
            <Form
                onSubmit={props.onSubmit}
                initialValues={props.initialData}
                mutators={{
                    ...arrayMutators
                }}
                render={({ handleSubmit, form: {
                mutators: { push, pop }
                }, values, form }) => {
                    return (
                        <form className="my-3" onSubmit={handleSubmit}>
                            <div className="row">
                                <FormField
                                    name="dateFrom"
                                    className="col-5"
                                    title={i18.Labels.DateFrom}
                                    component={FormFieldType.date}
                                />
                                <FormField
                                    name="dateTo"
                                    className="col-5"
                                    title={i18.Labels.DateTo}
                                    component={FormFieldType.date}
                                />
                                <FormField
                                    name="withDeleted"
                                    className="col-2"
                                    title={i18.Labels.WithDeleted}
                                    component={FormFieldType.checkbox}
                                />
                                <div className="px-0 col-12 text-right">
                                    <ButtonGroup>
                                        <Button
                                            htmlType="submit"
                                            type="primary"
                                            icon={<SaveOutlined />}
                                        >{trb(i18.Buttons.Submit)}</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </form>
                    );
                }}
            />
        </div>
    );
};